//PAQUETERIAS
import React, { useEffect, useState, useMemo, useRef} from "react";
import { CustomDialog, Confirm } from "react-st-modal";
import NotificationSystem from 'react-notification-system';

//COMPONENTES
import TableContainer from "../../main_components/Table/TableContainer";
import { get_products } from "../../services/inventory/inventory";
import CREATE_UPDATE from "./tools/create_update";
import MODAL_TABLE from "../../main_components/modal/modal_Table";
import AlertResponse from "../../main_components/alerts/alertResponse";
import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import SubTableContainer from "../../main_components/Table/SubTableContainer";
import { delete_products } from "../../services/inventory/inventory";
import { recovery_products } from "../../services/inventory/inventory";
import { SelectColumnFilter } from "../../components_cfdi/filters";

import FormControlLabel from "@mui/material/FormControlLabel";
//ESTILOS
import "../../components_cfdi/estilo.css";
import "../../components_cfdi/modal.css";
//IMAGENES/ICONOS
import SAVE from "../../imgComponents/save.png";
import DELETE from "../../imgComponents/borrar.png";
import CREATE from "../../imgComponents/create.png";
import VER from "../../imgComponents/reconsultaTable.png";

import TAX from "./tools/tax";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";
import "./products.css";
import { COLUMS_SHOW } from "../../main_components/Table/ColumsShow";
import {styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const PRODUCTS = (props) => {


  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
      margin: 1,
      padding: 0,
      transform: "translateX(6px)",
      "&.Mui-checked": {
        color: "#fff",
        transform: "translateX(22px)",
        "& .MuiSwitch-thumb:before": {
          backgroundImage: `url('data:image/svg+xml;base64,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')`,
        },
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
      width: 32,
      height: 32,
      "&:before": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMjAiIGhlaWdodD0iMjAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9ImZpbGw6IzQwQzA1NzsiPgo8cGF0aCBkPSJNIDIyLjc4MTI1IDAgQyAyMS42MDU0NjkgLTAuMDAzOTA2MjUgMjAuNDA2MjUgMC4xNjQwNjMgMTkuMjE4NzUgMC41MzEyNSBDIDEyLjkwMjM0NCAyLjQ5MjE4OCA5LjI4OTA2MyA5LjI2OTUzMSAxMS4yNSAxNS41OTM3NSBMIDExLjI1IDE1LjY1NjI1IEMgMTEuNTA3ODEzIDE2LjM2NzE4OCAxMi4xOTkyMTkgMTguNjE3MTg4IDEyLjYyNSAyMCBMIDkgMjAgQyA3LjMwMDc4MSAyMCA2IDIxLjMwMDc4MSA2IDIzIEwgNiA0NyBDIDYgNDguNjk5MjE5IDcuMzAwNzgxIDUwIDkgNTAgTCA0MSA1MCBDIDQyLjY5OTIxOSA1MCA0NCA0OC42OTkyMTkgNDQgNDcgTCA0NCAyMyBDIDQ0IDIxLjMwMDc4MSA0Mi42OTkyMTkgMjAgNDEgMjAgTCAxNC43NSAyMCBDIDE0LjQ0MTQwNiAxOS4wMDc4MTMgMTMuNTExNzE5IDE2LjA3NDIxOSAxMy4xMjUgMTUgTCAxMy4xNTYyNSAxNSBDIDExLjUxOTUzMSA5LjcyMjY1NiAxNC41IDQuMTA5Mzc1IDE5Ljc4MTI1IDIuNDY4NzUgQyAyNS4wNTA3ODEgMC44MzIwMzEgMzAuNjk1MzEzIDMuNzk2ODc1IDMyLjM0Mzc1IDkuMDYyNSBDIDMyLjM0Mzc1IDkuMDY2NDA2IDMyLjM0Mzc1IDkuMDg5ODQ0IDMyLjM0Mzc1IDkuMDkzNzUgQyAzMi41NzAzMTMgOS44ODY3MTkgMzMuNjU2MjUgMTMuNDA2MjUgMzMuNjU2MjUgMTMuNDA2MjUgQyAzMy43NDYwOTQgMTMuNzY1NjI1IDM0LjAyNzM0NCAxNC4wNTA3ODEgMzQuMzg2NzE5IDE0LjEzNjcxOSBDIDM0Ljc1IDE0LjIyNjU2MyAzNS4xMjg5MDYgMTQuMTA5Mzc1IDM1LjM3NSAxMy44MzIwMzEgQyAzNS42MjEwOTQgMTMuNTUwNzgxIDM1LjY5NTMxMyAxMy4xNjAxNTYgMzUuNTYyNSAxMi44MTI1IEMgMzUuNTYyNSAxMi44MTI1IDM0LjQzMzU5NCA5LjE3MTg3NSAzNC4yNSA4LjUzMTI1IEwgMzQuMjUgOC41IEMgMzIuNzgxMjUgMy43NjE3MTkgMjguNjAxNTYzIDAuNTQyOTY5IDIzLjkzNzUgMC4wNjI1IEMgMjMuNTUwNzgxIDAuMDIzNDM3NSAyMy4xNzE4NzUgMCAyMi43ODEyNSAwIFogTSAyNSAzMCBDIDI2LjY5OTIxOSAzMCAyOCAzMS4zMDA3ODEgMjggMzMgQyAyOCAzMy44OTg0MzggMjcuNjAxNTYzIDM0LjY4NzUgMjcgMzUuMTg3NSBMIDI3IDM4IEMgMjcgMzkuMTAxNTYzIDI2LjEwMTU2MyA0MCAyNSA0MCBDIDIzLjg5ODQzOCA0MCAyMyAzOS4xMDE1NjMgMjMgMzggTCAyMyAzNS4xODc1IEMgMjIuMzk4NDM4IDM0LjY4NzUgMjIgMzMuODk4NDM4IDIyIDMzIEMgMjIgMzEuMzAwNzgxIDIzLjMwMDc4MSAzMCAyNSAzMCBaIj48L3BhdGg+Cjwvc3ZnPg==')`,
      },
    },
    "& .MuiSwitch-track": {
      backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
      borderRadius: 20 / 2,
    },
  }));

  const [filtersColumsView, setfiltersColumsView] = useState(true);

  const columnNames = [
    "viewCode",
    "viewName",
    "viewDesc",
    "viewCodeB",
    "viewType",
    "viewUnit",
    "viewConv",
    "viewMin",
    "viewUSAT",
    "viewPieces",
    "viewPeso",
    "viewClas",
    "viewActive",
    "viewCSAT",
    "viewDMS"
  ];
  const initialState = columnNames.reduce((state, columnName) => {
    const storedValue = localStorage.getItem(`productos_${columnName}`);
    state[columnName] = 
    {
      value: storedValue === null ? true : storedValue === "true" ? true : false,
      set: (newValue) => {
        state[columnName].value = newValue;
        localStorage.setItem(`productos_${columnName}`, newValue);
        setshowColumns({ ...state });
      }
    }
    return state;
  }, {});
  const [showcolumns, setshowColumns] = useState(initialState);
  
  useEffect(()=>{
    columnNames.forEach((columnName) => {
      localStorage.setItem(`productos_${columnName}`, showcolumns[columnName].value);
    });
  },[showcolumns]);



  const [data, setData] = useState([]);
  const [modalT, setmodalT] = useState(true);
  const [menssage, setMenssage] = useState(true);
  const [deleted, setdeleted] = useState(false);
  const notificationSystemRef = useRef();

  const handleSubmit = async (a,b) => {
    setmodalT(true);
    setMenssage("Productos...");
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try {
            if(props.subtabla===true){
              console.log("entra dato")
              const dt = await get_products(sessionStorage.getItem("id_product_line"),deleted);
              setData(dt.data);
              setmodalT(false);
              if(a){
                handle_alert(b,a)
              }
            }else{
              const dt = await get_products(null,deleted);
              setData(dt.data);
              setmodalT(false);
              if(a){
                handle_alert(b,a)
              }
            }
           
          } catch (err) {
            setData([]);
            setMenssage("");
            setmodalT(false);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  };
  const handle_alert = (msj, status) => {
    if (status === true) {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={true}></AlertResponse>,
        level: "success",
        position: "br",
        autoDismiss: 10,
      });
    } else{
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={false}></AlertResponse>,
        level: "error",
        position: "br",
        autoDismiss: 60,
      });
    }
  };
  const handle_delete_product= async(id)=>{
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try {
            await delete_products(id)
            handle_reconsult(true,"Producto eliminado correctamente")
          } catch (err) {
            handle_alert(JSON.stringify(err?.response?.data),false)
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  }
  const handle_reconsult=(a,b)=>{
    if(a){
      handleSubmit(a,b);
    }else if(a===false){
      handle_alert(b,a);
    }
  }
  const handle_recovery = async(id)=>{
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try {
            await recovery_products(id)
            handleSubmit();
            handle_reconsult(true,"Producto recuperado correctamente")
          } catch (err) {
            handle_alert(JSON.stringify(err?.response?.data),false)
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  }
  useEffect(() => {
    handleSubmit();
  }, [deleted]);

  const columns = useMemo(
    () => [
      {
        id: "expander",
        Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => {
          return (
            <img
              alt=""
              title="Crear producto"
              src={CREATE}
              style={{display:sessionStorage.getItem("ROLE_INVENTORY_PRODUCTS")==="ROLE_INVENTORY_PRODUCTS"?"":"none"}}
              className="AddDatapointer"
              onClick={async () => {
                const result = await CustomDialog(
                  <CREATE_UPDATE
                    subtabla={props.subtabla}
                    name_line={props.subtabla===true?sessionStorage.getItem("id_product_line"):4}
                    code={""}
                    description={""}
                    enable={true}
                    method={"CREATE"}
                    name_supplier={null}
                    id_supp={null}
                    product_name={""}
                    barcode={""}
                    type={"CONGELADOS"}
                    product_line_data={"CLIENTE"}
                    only_promo={false}
                    cost={1}
                    pieces={1}
                    clave_prod_serv={""}
                    clave_unidad={""}
                    clave_unidad_2={""}
                    weight={0.1}
                    iva0={true}
                    iva16={false}
                    ieps8={false}
                    minimum_sales_unit={"PIEZA"}
                    minimum_sales_unit2={"PIEZA"}
                    unit={"LITROS"}
                    unit_dms={"ZCU"}
                    unit_conversion={0}
                    brand={"MORDISKO"}
                  ></CREATE_UPDATE>,
                  {
                    className: "modalProduct",
                    title: "Crear producto",
                    showCloseIcon: true,
                    isCanClose: false,
                  }
                );
                // eslint-disable-next-line no-lone-blocks
                {handle_reconsult(result?.validate,result?.msj)}
              }}
            ></img>
          );
        },
        Cell: ({ row }) => {
          function guardardato() {
            sessionStorage.setItem("id_product_tax", row.original.id);
          }

          return (
            <div>
              <a
                title="Configuración de impuestos"
                {...row.getToggleRowExpandedProps()}
              >
                {row?.isExpanded ? (
                  <span title="Configuración del impuesto">🔼</span>
                ) : (
                  <span
                    title="Configuración del impuesto"
                    onClick={guardardato}
                  >
                    🔽
                  </span>
                )}
              </a>
              <img
                alt=""
                style={{display:sessionStorage.getItem("ROLE_INVENTORY_PRODUCTS")==="ROLE_INVENTORY_PRODUCTS"?row.original.deleted_logical===true?"":"none":"none"}}
                title="Recuperar producto"
                src={VER}
                className="centerText, taxes"
                onClick={async () => {
                  const result = await Confirm(
                    "¿Esta usted seguro de recuperar este producto?",
                    "Recuperar Producto",
                    "Si",
                    "No"
                  );
                  if (result) {
                    handle_recovery(row.original.id)
                  } else {
                  }
                }}
              ></img>

              <img
                alt=""
                title="Actualizar producto"
                src={SAVE}
                style={{display:sessionStorage.getItem("ROLE_INVENTORY_PRODUCTS")==="ROLE_INVENTORY_PRODUCTS"?"":"none"}}
                onClick={async () => {
                  
                  const result = await CustomDialog(
                    
                    <CREATE_UPDATE
                      subtabla={props.subtabla}
                      id={row.original.id}
                      name_line={row.original.id_products_line_fk}
                      code={row.original.code}
                      description={row.original.description}
                      enable={row.original.enable}
                      method={"UPDATE"}
                      name_supplier={row.original.name_supplier}
                      id_supp={row.original.id_supp}
                      product_name={row.original.product_name}
                      barcode={row.original.barcode}
                      type={row.original.type}
                      product_line_data={row.original.product_line_data}
                      only_promo={row.original.only_promo}
                      cost={row.original.cost}
                      pieces={row.original.pieces}
                      clave_prod_serv={row.original.clave_prod_serv}
                      clave_unidad={row.original.clave_unidad}
                      clave_unidad_2={row.original.clave_unidad}
                      weight={row.original.weight}
                      iva0={row.original.iva0}
                      iva16={row.original.iva16}
                      ieps8={row.original.ieps8}
                      minimum_sales_unit={row.original.minimum_sales_unit}
                      minimum_sales_unit2={row.original.minimum_sales_unit_2}
                      unit={row.original.unit}
                      unit_dms={row.original.min_sales_unit_dms}
                      unit_conversion={row.original.unit_conversion}
                      brand={row.original.brand}
                    ></CREATE_UPDATE>,
                    {
                      className: "modalTItle",
                      title: "Actualizar producto",
                      showCloseIcon: true,
                      isCanClose: false,
                    }
                  );
                  // eslint-disable-next-line no-lone-blocks
                  {handle_reconsult(result?.validate,result?.msj)}
                }}
                className="centerText, taxes"
              ></img>

              <img
                alt=""
                title="Eliminar producto"
                src={DELETE}
                style={{display:sessionStorage.getItem("ROLE_INVENTORY_PRODUCTS")==="ROLE_INVENTORY_PRODUCTS"?"":"none"}}
                className="centerText, taxes"
                onClick={async () => {
                  const result = await Confirm(
                    "¿Esta usted seguro de eliminar este producto?",
                    "Eliminar Producto",
                    "Si",
                    "No"
                  );
                  if (result) {
                    if(row.original.enable === false){handle_delete_product(row.original.id)}
                    else{handle_alert("El producto debe estar marcado como no disponible", false)}
                    } else {}
                }}
              ></img>
            </div>
          );
        },
      },

      {
        Header: "Código",
        accessor: "code",
        show: showcolumns.viewCode.value,
        id:"code"
      },
      {
        Header: "Nombre del producto",
        accessor: "product_name",
        show: showcolumns.viewName.value,
        id: "product_name"
      },
      {
        Header: "Descripción",
        accessor: "description",
        show: showcolumns.viewDesc.value,
        id: "description"
      },
      {
        Header: "Código de barras",
        accessor: "barcode",
        show: showcolumns.viewCodeB.value,
        id: "barcode"
      },
      {
        Header: "Tipo",
        accessor: "type",
        Filter: SelectColumnFilter,
        show: showcolumns.viewType.value,
        id: "type"
      },
      {
        Header: "Unidad",
        accessor: "unit",
        Filter: SelectColumnFilter,
        show: showcolumns.viewUnit.value,
        id: "unit"
      },
      {
        Header: "Conversión",
        accessor: "unit_conversion",
        show: showcolumns.viewConv.value,
        id: "unit_conversion"
      },
      {
        Header: "Minima",
        accessor: "minimum_sales_unit",
        Filter: SelectColumnFilter,
        show: showcolumns.viewMin.value,
        id:"minimum_sales"
      },
      {
        Header: "Unidad SAT",
        accessor: "clave_unidad",
        show: showcolumns.viewUSAT.value,
        id: "clave_unidad"
      },
      {
        Header: "Piezas",
        accessor: "pieces",
        show: showcolumns.viewPieces.value,
        id: "pieces"
      },
      {
        Header: "Peso",
        accessor:"weight",
        show: showcolumns.viewPeso.value,
        id: "weight"
      },
      {
        Header: "Clasificación",
        accessor: "brand",
        Filter: SelectColumnFilter,
        show: showcolumns.viewClas.value,
        id: "brand"
      },
      {
        Header: "Activo",
        Filter: SelectColumnFilter,
        accessor: (d) => {
          return d.enable === true ? "Si" : "NO";
        },
        show: showcolumns.viewActive.value,
        id: "enable"
      },
      {
        Header: "Clave SAT",
        accessor: "clave_prod_serv",
        show: showcolumns.viewCSAT.value,
        id: "clave_prod_serv"
      },
      {
        Header: "Clave DMS",
        accessor: "min_sales_unit_dms",
        Filter: SelectColumnFilter,
        show: showcolumns.viewDMS.value,
        id: "min_sales_unit_dms"
      },      
    ],
    [
      showcolumns
    ]
  );
  const handlechecked = (event) => {
    setfiltersColumsView(event.target.checked);
  };
  
  const datacolumns = [
    {
      view: showcolumns.viewCode.value,
      setview: (newValue) => showcolumns.viewCode.set(newValue),
      label: "Código"
    },
    {
      view: showcolumns.viewName.value,
      setview: (newValue) => showcolumns.viewName.set(newValue),
      label: "Nombre del Producto"
    },
    {
      view: showcolumns.viewDesc.value,
      setview: (newValue) => showcolumns.viewDesc.set(newValue),
      label: "Descripción"
    },
    {
      view: showcolumns.viewCodeB.value,
      setview: (newValue) => showcolumns.viewCodeB.set(newValue),
      label: "Código de Barras"
    },
    {
      view: showcolumns.viewType.value,
      setview: (newValue) => showcolumns.viewType.set(newValue),
      label: "Tipo"
    },
    {
      view: showcolumns.viewUnit.value,
      setview: (newValue) => showcolumns.viewUnit.set(newValue),
      label: "Unidad"
    },
    {
      view: showcolumns.viewConv.value,
      setview: (newValue) => showcolumns.viewConv.set(newValue),
      label: "Conversión"
    },
    {
      view: showcolumns.viewMin.value,
      setview: (newValue) => showcolumns.viewMin.set(newValue),
      label: "Mínima"
    },
    {
      view: showcolumns.viewUSAT.value,
      setview: (newValue) => showcolumns.viewUSAT.set(newValue),
      label: "Unidad SAT"
    },
    {
      view: showcolumns.viewPieces.value,
      setview: (newValue) => showcolumns.viewPieces.set(newValue),
      label: "Piezas"
    },
    {
      view: showcolumns.viewPeso.value,
      setview: (newValue) => showcolumns.viewPeso.set(newValue),
      label: "Peso"
    },
    {
      view: showcolumns.viewClas.value,
      setview: (newValue) => showcolumns.viewClas.set(newValue),
      label: "Clasificación"
    },
    {
      view: showcolumns.viewActive.value,
      setview: (newValue) => showcolumns.viewActive.set(newValue),
      label: "Activo"
    },
    {
      view: showcolumns.viewCSAT.value,
      setview: (newValue) => showcolumns.viewCSAT.set(newValue),
      label: "Clave SAT"
    },
    {
      view: showcolumns.viewDMS.value,
      setview: (newValue) => showcolumns.viewDMS.set(newValue),
      label: "Clave DMS"
    }
  ]


  return (
    <div className="">
      <MODAL_TABLE open={true} modalT={modalT}></MODAL_TABLE>
      <NotificationSystem  ref={notificationSystemRef} ></NotificationSystem>
      <BREADCRUMBS niveles={
            [
              {label: "CONSULTAR PRODUCTOS", path: null},
            ]
          }
      ></BREADCRUMBS>
        <COLUMS_SHOW
            filtersColumsView={filtersColumsView}
            datacolums={datacolumns}
         />
      <div className="selectProduct" style={{display:props.subtabla===true?"none":""}}>
        <select name="" id="" onChange={(e)=>setdeleted(e.target.value)}>
          <option value={false}>Vigentes</option>
          <option value={true}>Eliminados</option>
        </select>
      </div>
    
          
          <div className="containerCutBox">
                <div className="expen-8 color-1">
                  <FormControlLabel
                    control={
                      <MaterialUISwitch
                        sx={{ m: 1 }}
                        onChange={handlechecked}
                        checked={filtersColumsView}
                      />
                    }
                    label={
                      filtersColumsView === true
                        ? "Activar Filtros"
                        : "Desactivar Filtros"
                    }
                  />
                </div>
            </div>

      <div className="TableTaxes TableProduct">
        <div className="">
          <TableContainer
            columns={columns}
            data={data}
            exportar={true}
            style={{ overflowx: 10 }}
            renderRowSubComponent={(row) => {
              return (
                <div style={{ padding: "20px" }}>
                  <TAX />
                </div>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PRODUCTS;
